export default "__VITE_ASSET__DHS6IMOo__"